import React, { Component, useEffect, useRef } from "react";
import PropTypes from "prop-types";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import remarkMath from "remark-math";
import rehypeKatex from "rehype-katex";

const cssLoaded = { current: false };

function useKatexCss() {
  const done = useRef(cssLoaded.current);
  useEffect(() => {
    if (done.current) return;
    done.current = true;
    cssLoaded.current = true;
    const link = document.createElement("link");
    link.rel = "stylesheet";
    link.href = "https://cdn.jsdelivr.net/npm/katex@0.16.38/dist/katex.min.css";
    link.crossOrigin = "anonymous";
    document.head.appendChild(link);
  }, []);
}

function normalizeLatex(text) {
  if (!text) return text;
  let out = text;
  out = out.replace(/\\\[/g, () => "$$");
  out = out.replace(/\\\]/g, () => "$$");
  out = out.replace(/\\\(/g, () => "$");
  out = out.replace(/\\\)/g, () => "$");
  return out;
}

class MathBoundary extends Component {
  state = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.content !== this.props.content && this.state.hasError) {
      this.setState({ hasError: false });
    }
  }

  render() {
    if (this.state.hasError) {
      return (
        <ReactMarkdown remarkPlugins={[remarkGfm]}>
          {this.props.content}
        </ReactMarkdown>
      );
    }
    return this.props.children;
  }
}

MathBoundary.propTypes = {
  content: PropTypes.string,
  children: PropTypes.node,
};

const containStyle = { contain: "layout paint", overflow: "hidden" };

export default function MarkdownRenderer({ content }) {
  useKatexCss();
  const normalized = normalizeLatex(content);
  return (
    <MathBoundary content={normalized}>
      <div style={containStyle}>
        <ReactMarkdown
          remarkPlugins={[remarkGfm, remarkMath]}
          rehypePlugins={[rehypeKatex]}
        >
          {normalized}
        </ReactMarkdown>
      </div>
    </MathBoundary>
  );
}

MarkdownRenderer.propTypes = {
  content: PropTypes.string,
};
